import { useEffect } from "react";
import { PublicLayout } from "@/components/layout/PublicLayout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const SYSTEMS = [
  { name: "Application", status: "operational" as const },
  { name: "API", status: "operational" as const },
  { name: "Authentication", status: "operational" as const },
  { name: "Database", status: "operational" as const },
];

// Placeholder for future incidents (hardcoded empty for now)
const INCIDENTS: { date: string; title: string; resolved: boolean }[] = [];

export default function StatusPage() {
  useEffect(() => {
    document.title = "Status | Decision Sales OS";
  }, []);

  return (
    <PublicLayout showCookieBanner={false}>
      <h1 className="text-3xl font-semibold tracking-tight mb-4">System status</h1>
      <p className="text-muted-foreground mb-8">
        Current status of our services.
      </p>

      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <span className="h-3 w-3 rounded-full bg-green-500" aria-hidden />
            All systems operational
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2">
            {SYSTEMS.map((s) => (
              <li key={s.name} className="flex items-center justify-between">
                <span>{s.name}</span>
                <Badge variant="outline" className="text-green-600 border-green-600/50">
                  Operational
                </Badge>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Past incidents</CardTitle>
        </CardHeader>
        <CardContent>
          {INCIDENTS.length === 0 ? (
            <p className="text-muted-foreground text-sm">No incidents in the current period.</p>
          ) : (
            <ul className="space-y-2 text-sm">
              {INCIDENTS.map((inc, i) => (
                <li key={i} className="flex items-center gap-2">
                  <span className="text-muted-foreground">{inc.date}</span>
                  <span>{inc.title}</span>
                  {inc.resolved && <Badge variant="secondary">Resolved</Badge>}
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </PublicLayout>
  );
}
